import { render } from "./DropdownList.vue?vue&type=template&id=59563f3a&scoped=true"
import script from "./DropdownList.vue?vue&type=script&lang=js"
export * from "./DropdownList.vue?vue&type=script&lang=js"

import "./DropdownList.vue?vue&type=style&index=0&id=59563f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59563f3a"]])

export default __exports__